import HermesV10Fitter from './../../hermesComponents/hermes-v10-fitter/index.vue';
import MarsText from './../../hermesComponents/mars-text/index.vue';
export default (Vue) => {
   Vue.component('HermesV10Fitter', HermesV10Fitter);
 Vue.component('MarsText', MarsText);
}